import React, { Component } from "react";
import "./css/desktop-modern.css";
import { buildMobileAppUrl, isDesktopViewport } from "../../helpers/appRouting";

/* ── SVG icons ────────────────────────────────────────────── */
const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 6l3 3 5-5" stroke="#FF5E35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const PlayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3"/>
  </svg>
);
const MobileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
    <line x1="12" y1="18" x2="12.01" y2="18"/>
  </svg>
);
const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

/* ── Static data ──────────────────────────────────────────── */
const YT_ID = "RLAL-3hWfQ8";

const SERVICES = [
  { img:"1", title:"דרופ שיפ",          desc:"בפני מוסדות ודרופ שיפרים ניתן להתממשק למערך הלוגיסטי ולבצע אינטגרציה שיכולה לתת מענה לכל מי שעוסק בתחום" },
  { img:"2", title:"חברות ומוסדות",     desc:"ברגע שתתחילו להשתמש תבינו את ההבדל – תוכלו לקבל דירוגים וחוויות משתמש מהלקוחות ולנהל את העסק טוב יותר" },
  { img:"3", title:"עסקים",             desc:"האפליקציה פותחה במיוחד לבתי עסק שעובדים סביב השעון ובעלי צורך בקליטה וניהול הזמנות מהירות, נותנת מענה לכל גודל" },
  { img:"4", title:"חברות שילוח",       desc:"אנו מציעים את שירותנו גם לחברות שילוח הזקוקות לכלים ופתרונות עבור הנהגים והעסקים לצמצום עלויות והגדלת הזמינות" },
  { img:"5", title:"אוטומציה לעסק",    desc:"המערכת מספקת שירותים אוטומטיים ומציעה שירותים נוספים כמו נגן מוזיקה ווידאו ואפליקציה להפניית SMS למתקשרים לעסק" },
  { img:"6", title:"מודל מבוסס מיקום", desc:"המערכת מבוססת מיקום ומעניקה נוחות משתמש גבוהה בכל מקום כך שהעסקים זמינים ישירות מהנייד לביצוע הזמנה ומעקב" },
];

const DELIVERY_FEATURES = [
  { img:"feature1.svg", title:"חיבור שליחים ונהגים לכל עסק",  desc:"העסקים יכולים לעבוד עם מספר רב של שליחים. ניתן לדרג את איכות המשלוח ולנהל את הצוות בצורה קלה." },
  { img:"feature2.svg", title:"סטאטוסים והתראות",              desc:"המערכת עוקבת אחר המשלוחים וההזמנות – בכל שלב השליחים מעדכנים את הסטאטוס בזמן אמת לעסק וללקוח." },
  { img:"feature3.svg", title:"ממשק קל, מהיר ונוח",            desc:"הנהגים מקבלים את כל המידע הנחוץ: כתובות, הוראות הגעה, טיפים, עודף ומידע על ערוץ ההזמנה." },
];

const PARTNERS = [
  { img:"t1.png", label:"בתי עסק על משלוחים ואיסוף עצמי" },
  { img:"t2.png", label:"מרכזי לוגיסטיקה ושילוח" },
  { img:"t3.png", label:"נהגים או שליחים" },
  { img:"t4.png", label:"חברות הובלה" },
  { img:"t5.png", label:"חברות תיירות וסוכני נסיעות" },
  { img:"t6.png", label:"מרכזי הזמנה לחופשות וכרטיסים" },
];

const FAQS_CUSTOMERS = [
  { q:"אני לקוח חדש, כיצד אני מתחיל?",  a:"לאחר הזנת הכתובת כבר ניתן להתחיל להזמין. בסוף ההזמנה תצטרכו להירשם. ניתן להשתמש בלחצן \"התחבר באמצעות גוגל\" ולאחריו להוסיף מספר טלפון." },
  { q:"איך אני יודע מתי ההזמנה תגיע?",  a:"לאחר הרשמה לאפליקציה, בלשונית חשבון תוכלו להיכנס להזמנות שלי ולראות את סטטוס ההזמנה הנוכחי. תקבלו התראות בכל שינוי סטאטוס." },
  { q:"אם ההזמנה לא הגיעה?", aNode:(<p>הזמנות שאושרו ובית העסק לא סיפק אותן יזוכו לאחר ביטולן לארנק באפליקציה. פנו אלינו בטלפון <a href="tel:0795244889">079-524-48-89</a> במידה ולא קיבלתם זיכוי.</p>) },
  { q:"איך להשתמש באפליקציה?",           a:"מכל מכשיר עם דפדפן ניתן לגלוש, להירשם ולאחר מכן להוסיף למסך הבית. תראו את האייקון במסך הבית ותוכלו להשתמש כמו אפליקציה רגילה." },
];

const FAQS_STORES = [
  { q:"אני עסק חדש, כיצד אני מתחיל?", aNode:(<p>לאחר הרשמה בכתובת <a href="//my.tuk.to">my.tuk.to</a>. במידה ואינכם יודעים איך לעשות זאת פנו אלינו באמצעות מייל או טלפון ואנו נעשה זאת עבורכם.</p>) },
  { q:"איך אני מכניס מוצרים ורואה אותם באפליקציה?", a:"לאחר ההרשמה תוכל להתחבר דרך ממשק הניהול ולהתחיל לבנות את התפריט. לאחר שתסיים ניצור איתך קשר ונאשר את החנות לפעילות מלאה." },
  { q:"לאן אני מפנה את הלקוחות?", aNode:(<p>לאחר שהעסק אושר נספק לכם קישור ייחודי: <a href="//tuk.to/stores/pizza-nehemia">tuk.to/stores/שם-העסק</a>. תוכלו לשתף אותו או להטמיע באתר שלכם.</p>) },
  { q:"איך אני מחבר שליחים לעסק שלי?", aNode:(<p>שליחים נרשמים למערכת בכתובת <a href="//my.tuk.to">my.tuk.to</a>. לאחר יצירת קשר נוודא שהשליח מורשה לעבוד איתך והוא יוכל להתחיל לקבל הזמנות.</p>) },
];

/* ─────────────────────────────────────────────────────────── */

class Hero extends Component {
  /* Same breakpoint used in App/index.js */
  _isDesktop = () => isDesktopViewport();

  videoRef  = React.createRef();
  _observer = null;

  state = {
    menuOpen:      false,
    dropdownOpen:  false,
    sticky:        false,
    showScrollTop: false,
    appStarted:    false,
    videoReady:    false,
    faqTab:        "customers",
    faqClients:    [false, false, false, false],
    faqStores:     [false, false, false, false],
  };

  componentDidMount() {
    /* Auto-start app when arriving with a specific store/item link */
    if (this.props.itemId || this.props.restaurant) {
      this._startApp();
    }
    window.addEventListener("scroll", this._onScroll);

    /* Load YouTube iframe when video section enters viewport */
    if ("IntersectionObserver" in window && this.videoRef.current) {
      this._observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.setState({ videoReady: true });
            this._observer.disconnect();
          }
        },
        { threshold: 0.25 }
      );
      this._observer.observe(this.videoRef.current);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this._onScroll);
    if (this._observer) this._observer.disconnect();
  }

  _onScroll = () => {
    const y = window.scrollY;
    this.setState({ sticky: y > 60, showScrollTop: y > 500 });
  };

  _startApp = (e) => {
    if (e) e.preventDefault();
    if (!this._isDesktop()) {
      window.location.href = this._getMobileAppUrl();
      return;
    }
    this.setState({ appStarted: true });
  };

  _learnMore = (e) => {
    e.preventDefault();
    const el = document.getElementById("video");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  _toggleMenu = () => this.setState((s) => ({ menuOpen: !s.menuOpen, dropdownOpen: false }));
  _closeMenu  = () => this.setState({ menuOpen: false, dropdownOpen: false });
  _toggleDD   = (e) => { e.stopPropagation(); this.setState((s) => ({ dropdownOpen: !s.dropdownOpen })); };

  _toggleFaqClient = (i) => { const a = [...this.state.faqClients]; a[i] = !a[i]; this.setState({ faqClients: a }); };
  _toggleFaqStore  = (i) => { const a = [...this.state.faqStores];  a[i] = !a[i]; this.setState({ faqStores:  a }); };

  _scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  _getMobileAppUrl = () => {
    const { restaurant, itemId } = this.props;
    return buildMobileAppUrl({ restaurant, itemId });
  };

  render() {
    const { menuOpen, dropdownOpen, sticky, showScrollTop, appStarted, videoReady, faqTab, faqClients, faqStores } = this.state;
    /* URL that loads the Mobile React component inside the iframe / on mobile nav */
    const mobileAppUrl = this._getMobileAppUrl();
    const isDesktop    = this._isDesktop();

    return (
      <div className="dk-root" dir="rtl">

        {/* ══ NAV ═════════════════════════════════════════════════ */}
        <header className={`dk-nav${sticky ? " dk-nav--sticky" : ""}`}>
          <div className="dk-nav-inner">
            <a href="//tuk.to" className="dk-nav-logo">
              <img src="/assets/img/logos/logo.png" alt="Tuk.To" />
            </a>

            {/* Desktop links — hidden on mobile */}
            <nav className="dk-nav-links">
              <a href="#home">דף הבית</a>
              <a href="#how">איך זה עובד</a>
              <a href="#services">שירותים</a>
              <a href="//tuk.to/delivery">אפליקציית שליחים</a>
              <a href="#contact">צור קשר</a>
            </nav>

            {/* Desktop CTAs */}
            <div className="dk-nav-actions">
              <a href="//my.tuk.to" className="dk-btn dk-btn--outline dk-btn--sm">עסקים / שליחים</a>
              <button className="dk-btn dk-btn--primary dk-btn--sm" onClick={this._startApp}>
                הזמן עכשיו
              </button>
            </div>

            {/* Hamburger — mobile only */}
            <button
              className={`dk-nav-toggle${menuOpen ? " open" : ""}`}
              onClick={this._toggleMenu}
              aria-label={menuOpen ? "סגור תפריט" : "פתח תפריט"}
              aria-expanded={menuOpen}
            >
              <span /><span /><span />
            </button>
          </div>

          {/* Mobile slide-down panel */}
          {menuOpen && (
            <div className="dk-mobile-panel" role="dialog" aria-modal="true">
              {/* Primary CTAs at the top */}
              <div className="dk-mobile-panel-ctas">
                <button
                  className="dk-btn dk-btn--primary dk-btn--block dk-btn--lg"
                  onClick={(e) => { this._closeMenu(); this._startApp(e); }}
                >
                  הזמן עכשיו
                </button>
                <a href="//my.tuk.to" className="dk-btn dk-btn--outline dk-btn--block"
                  onClick={this._closeMenu}>
                  כניסה / הרשמה לעסקים
                </a>
                <a href="//my.tuk.to" className="dk-btn dk-btn--outline dk-btn--block"
                  onClick={this._closeMenu}>
                  הרשמה לשליחים ונהגים
                </a>
              </div>

              {/* Nav links */}
              <div className="dk-mobile-panel-links">
                <a href="#home"              onClick={this._closeMenu}>דף הבית</a>
                <a href="#how"               onClick={this._closeMenu}>איך זה עובד</a>
                <a href="#services"          onClick={this._closeMenu}>שירותים</a>
                <a href="//tuk.to/delivery" onClick={this._closeMenu}>אפליקציית שליחים (לאחר הרשמה)</a>
                <a href="#contact"           onClick={this._closeMenu}>צור קשר</a>
              </div>
            </div>
          )}
        </header>

        {/* ══ HERO ════════════════════════════════════════════════ */}
        <section id="home" className="dk-hero">
          <div className="dk-hero-blob dk-hero-blob-1" aria-hidden="true" />
          <div className="dk-hero-blob dk-hero-blob-2" aria-hidden="true" />
          <div className="dk-hero-dots"                aria-hidden="true" />

          <div className="dk-container dk-hero-inner">

            {/* Text */}
            <div>
              <div className="dk-hero-badge">
                <span className="dk-hero-badge-dot" aria-hidden="true" />
                פלטפורמת הזמנות מתקדמת
              </div>

              <h1 className="dk-hero-title">
                {localStorage.getItem("desktopHeading") || (<>הזמן, נהל ושלח{" "}<span className="dk-grad">בקלות</span></>)}
              </h1>

              <p className="dk-hero-sub"
                dangerouslySetInnerHTML={{ __html: localStorage.getItem("desktopSubHeading") || "פלטפורמה לעסקים, לקוחות ושליחים" }}
              />

              {/* Two primary CTAs */}
              <div className="dk-hero-ctas-row">
                <button className="dk-btn dk-btn--primary dk-btn--lg" onClick={this._startApp}>
                  <MobileIcon /> הזמן עכשיו
                </button>
                <a href="#video" className="dk-btn dk-btn--ghost dk-btn--lg" onClick={this._learnMore}>
                  גלה עוד ↓
                </a>
              </div>

              {/* Business + driver registration link */}
              <div className="dk-hero-biz-link">
                <a href="//my.tuk.to">בעל עסק או שליח? הירשם וכנס כאן ←</a>
              </div>

              {/* Mobile-only choice block — replaces the phone mockup on small screens */}
              <div className="dk-mobile-choice">
                <button
                  className="dk-mobile-choice-btn dk-mobile-choice-btn--enter"
                  onClick={this._startApp}
                >
                  <strong>כנס לאפליקציה</strong>
                  <span>לקוחות · הזמנת אוכל ומשלוחים</span>
                </button>

                <div className="dk-mobile-choice-or">או</div>

                <a
                  href="#video"
                  className="dk-mobile-choice-btn dk-mobile-choice-btn--explore"
                  onClick={this._learnMore}
                >
                  <strong>גלה עוד על הפלטפורמה</strong>
                  <span>לעסקים ושליחים · פיצ׳רים ומידע</span>
                </a>
              </div>

              <div className="dk-hero-trust">
                {["ללא עמלה","הגדרה תוך 5 דקות","תמיכה מלאה"].map((label, i) => (
                  <div className="dk-trust-item" key={i}>
                    <span className="dk-trust-dot"><CheckIcon /></span>
                    {label}
                  </div>
                ))}
              </div>
            </div>

            {/* Phone mockup — desktop only */}
            <div className="dk-hero-phone-wrap">

              <div className={`dk-phone${appStarted ? " dk-phone--active" : ""}`}>
                <div className="dk-phone-notch" aria-hidden="true" />
                <div className="dk-phone-screen">
                  {isDesktop && appStarted ? (
                    <iframe title="Tuk.To App" src={mobileAppUrl} className="dk-phone-iframe" />
                  ) : (
                    <img className="dk-phone-preview"
                      src="//d28z95jp6vevzz.cloudfront.net/img/desktop/phonex.png" alt="App preview" />
                  )}
                </div>

                {isDesktop && !appStarted && (
                  <div className="dk-phone-overlay">
                    <div className="dk-phone-overlay-icon"><MobileIcon /></div>
                    <p>לחץ להפעלה</p>
                    <button className="dk-btn dk-btn--primary dk-btn--sm" onClick={this._startApp}>
                      הזמן עכשיו
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* ══ VIDEO ═══════════════════════════════════════════════ */}
        <section id="video" className="dk-video-section" ref={this.videoRef}>
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag">סרטון הסבר</div>
              <h2 className="dk-sec-title">ראו איך זה עובד</h2>
              <p className="dk-sec-desc">הסבר קצר על הפלטפורמה ואיך זה עובד</p>
            </div>
            <div className="dk-video-wrap">
              {videoReady ? (
                <iframe
                  title="Tuk.To Platform Overview"
                  src={`https://www.youtube.com/embed/${YT_ID}?autoplay=1&mute=0&playsinline=1&rel=0&modestbranding=1&controls=1`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <div className="dk-video-placeholder">
                  <div className="dk-video-play-icon"><PlayIcon /></div>
                  <span>טוען סרטון...</span>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* ══ HOW IT WORKS ════════════════════════════════════════ */}
        <section id="how" className="dk-section dk-section-alt">
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag">איך זה עובד</div>
              <h2 className="dk-sec-title">שלושה צעדים פשוטים</h2>
              <p className="dk-sec-desc">תפריט, הזמנות ושליחים – הכל בפלטפורמה אחת</p>
            </div>
            <div className="dk-steps">
              <div className="dk-step">
                <div className="dk-step-icon"><img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/icons/h1.png" alt="" /></div>
                <h4>רישום מהיר</h4>
                <p>נרשמים למערכת בקישור <a href="//my.tuk.to">my.tuk.to</a> – לאחר הזדהות העסק מקבלים מספר מסוף אשראי ומתחילים לעבוד</p>
              </div>
              <div className="dk-step">
                <div className="dk-step-icon"><img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/icons/h2.png" alt="" /></div>
                <h4>הכנסת תפריטים ומוצרים</h4>
                <p>מכניסים את התפריט על ידי העלאת קובץ או ידנית – מגוון אפשרויות לבניית והצגת המוצרים</p>
              </div>
              <div className="dk-step">
                <div className="dk-step-icon"><img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/icons/h3.png" alt="" /></div>
                <h4>המוצרים עולים מיידית לאפליקציה</h4>
                <p>המוצרים יופיעו לקהל הלקוחות ותקבלו קישור ייחודי לחנות שלכם לכל פלטפורמת פרסום</p>
              </div>
            </div>
          </div>
        </section>

        {/* ══ ABOUT 1 ═════════════════════════════════════════════ */}
        <section className="dk-section">
          <div className="dk-container">
            <div className="dk-about">
              <div className="dk-about-text">
                <div className="dk-tag">מערכת חכמה</div>
                <h3>מערכת התראות חכמה</h3>
                <p>מעכשיו לא צריך שיחות – הלקוחות מקבלים התראות לאורך כל ההזמנה, מה שמקצר משמעותית את התהליך ונותן לעסק, לשליח וללקוח את ההתראות בזמן אמת.</p>
                <p>בנוסף המערכת שולחת SMS בעת קבלת הזמנה מלקוח ובעת אישור ההזמנה על ידי בית העסק ישירות לשליח.</p>
                <a href="//my.tuk.to" className="dk-btn dk-btn--business">כניסה למערכת</a>
              </div>
              <div className="dk-about-img">
                <img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/core-img/about1.png" alt="מערכת התראות" />
              </div>
            </div>
          </div>
        </section>

        {/* ══ ABOUT 2 ═════════════════════════════════════════════ */}
        <section className="dk-section dk-section-alt">
          <div className="dk-container">
            <div className="dk-about dk-about--flip">
              <div className="dk-about-img">
                <img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/core-img/about2.png" alt="קל ומהיר" />
              </div>
              <div className="dk-about-text">
                <div className="dk-tag dk-tag--purple">זמין בכל מקום</div>
                <h3>הדרך הקלה והמהירה לך ולקהל הלקוחות שלך</h3>
                <p>המערכת שלנו נמצאת בענן ועובדת במהירות מכל מכשיר דור 4 ומעלה.</p>
                <p>המערכת פתוחה למגוון ענפים וערוכה לגדול ולהגיע לקהל עסקים גדול.</p>
                <a href="//my.tuk.to" className="dk-btn dk-btn--primary">הצטרף עכשיו</a>
              </div>
            </div>
          </div>
        </section>

        {/* ══ SERVICES ════════════════════════════════════════════ */}
        <section id="services" className="dk-section">
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag">השירותים שלנו</div>
              <h2 className="dk-sec-title">פתרונות לכל צורך</h2>
              <p className="dk-sec-desc">כלים לניהול, אוטומציה ושיחות לכל עסק</p>
            </div>
            <div className="dk-services">
              {SERVICES.map((s, i) => (
                <div className="dk-svc" key={i}>
                  <div className="dk-svc-icon"><img src={`//d28z95jp6vevzz.cloudfront.net/img/desktop/services/${s.img}.png`} alt={s.title} /></div>
                  <h5>{s.title}</h5>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ══ LOCATION ════════════════════════════════════════════ */}
        <section className="dk-section dk-section-alt">
          <div className="dk-container">
            <div className="dk-location">
              <div>
                <div className="dk-tag">הכיסוי שלנו</div>
                <h3 className="dk-location-title">לכל מקום מכל מקום</h3>
                <ul className="dk-checklist">
                  {["אנו כבר נמצאים בתל אביב","אנו פותחים את ההרשמה ללקוחות מכל אזור בארץ","אתם מוזמנים לנסות את המערכת בחינם למשך חודשיים"].map((item, i) => (
                    <li key={i}><span className="dk-check-icon" aria-hidden="true"><CheckIcon /></span>{item}</li>
                  ))}
                </ul>
                <a href="//my.tuk.to" className="dk-btn dk-btn--primary">כניסה למערכת</a>
              </div>
              <div className="dk-location-map">
                <img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/map-il2.png" alt="מפת ישראל" />
              </div>
            </div>
          </div>
        </section>

        {/* ══ DELIVERY ════════════════════════════════════════════ */}
        <section className="dk-section">
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag dk-tag--teal">לשליחים ונהגים</div>
              <h2 className="dk-sec-title">אפליקציה לשליחים ונהגים</h2>
              <p className="dk-sec-desc">זמין לשליחים רשומים – <a href="//tuk.to/delivery" style={{color:"var(--dk-orange)",fontWeight:700}}>התחברות לשליח</a></p>
            </div>
            <div className="dk-delivery">
              <div className="dk-delivery-features">
                {DELIVERY_FEATURES.map((f, i) => (
                  <div className="dk-delivery-feat" key={i}>
                    <div className="dk-feat-icon"><img src={`//d28z95jp6vevzz.cloudfront.net/img/desktop/svg/${f.img}`} alt="" /></div>
                    <div className="dk-feat-text">
                      <h5><a href="//tuk.to/delivery">{f.title}</a></h5>
                      <p>{f.desc}</p>
                    </div>
                  </div>
                ))}
                <a href="//tuk.to/delivery" className="dk-btn dk-btn--driver dk-mt-4">התחברות לשליח</a>
              </div>
              <div className="dk-delivery-img">
                <img src="//d28z95jp6vevzz.cloudfront.net/img/desktop/phonex.png" alt="Delivery App" />
              </div>
            </div>
          </div>
        </section>

        {/* ══ PARTNERSHIPS ════════════════════════════════════════ */}
        <section className="dk-section dk-section-alt">
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag dk-tag--purple">שיתופי פעולה</div>
              <h2 className="dk-sec-title">אם אתם מאחד הענפים</h2>
              <p className="dk-sec-desc">יכול להיות שכדאי שנשתף פעולה</p>
            </div>
            <div className="dk-partners">
              {PARTNERS.map((p, i) => (
                <div className="dk-partner" key={i}>
                  <div className="dk-partner-icon"><img src={`//d28z95jp6vevzz.cloudfront.net/img/desktop/icons/${p.img}`} alt="" /></div>
                  <span>{p.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ══ FAQ ═════════════════════════════════════════════════ */}
        <section className="dk-section">
          <div className="dk-container">
            <div className="dk-sec-head">
              <div className="dk-tag">שאלות ותשובות</div>
              <h2 className="dk-sec-title">{localStorage.getItem("accountHelpFaq") || "שאלות נפוצות"}</h2>
              <p className="dk-sec-desc">שאלות ותשובות ללקוחות ועסקים</p>
            </div>
            <div className="dk-faq-wrap">
              <div className="dk-faq-tabs" role="tablist">
                <button role="tab" aria-selected={faqTab==="customers"} className={`dk-faq-tab${faqTab==="customers"?" active":""}`} onClick={() => this.setState({faqTab:"customers"})}>לקוחות</button>
                <button role="tab" aria-selected={faqTab==="stores"}    className={`dk-faq-tab${faqTab==="stores"   ?" active":""}`} onClick={() => this.setState({faqTab:"stores"})}>בעלי עסקים</button>
              </div>
              {faqTab==="customers" && FAQS_CUSTOMERS.map((item,i) => (
                <div className="dk-faq-item" key={i}>
                  <button className={`dk-faq-q${faqClients[i]?" open":""}`} onClick={() => this._toggleFaqClient(i)} aria-expanded={faqClients[i]}>
                    {item.q}<span className="dk-faq-chevron" aria-hidden="true">▾</span>
                  </button>
                  {faqClients[i] && <div className="dk-faq-a">{item.aNode||<p>{item.a}</p>}</div>}
                </div>
              ))}
              {faqTab==="stores" && FAQS_STORES.map((item,i) => (
                <div className="dk-faq-item" key={i}>
                  <button className={`dk-faq-q${faqStores[i]?" open":""}`} onClick={() => this._toggleFaqStore(i)} aria-expanded={faqStores[i]}>
                    {item.q}<span className="dk-faq-chevron" aria-hidden="true">▾</span>
                  </button>
                  {faqStores[i] && <div className="dk-faq-a">{item.aNode||<p>{item.a}</p>}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>

        {showScrollTop && (
          <button className="dk-scroll-top" onClick={this._scrollTop} aria-label="גלול למעלה">↑</button>
        )}
      </div>
    );
  }
}

export default Hero;
